import React from "react";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { url } from "../../Constant";
import axios from "axios";
import $ from "jquery";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../Context/AuthProvider";
import { checkIndividualPermission,checkPermissions } from "../../Utils/PermissionFunctions";

const OutboundSoundSetting = () => {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const [errorEnable, setErrorEnable] = useState(false);
  const [loader, setLoader] = useState(false);
  const [audioForm, setAudioForm] = useState([]);
  const [noOfAudios, setNoOfAudios] = useState();
  const [selectedType, setSelectedType] = useState("");
  const [audio, setaudio] = useState({});
  const [fileData, setFileData] = useState([]);
  const [submittedData, setSubmittedData] = useState({
    vpbx_id: auth.vpbx_id,
    no_of_audios: "",
    type: "",
  });

  const [finalData, setFinalData] = useState();

  const [mediaArray, setMediaArray] = useState([]);

  const createIvr = () => {
    setErrorEnable(true);
    setLoader(true);
    var formData = new FormData();

    formData.append("vpbx_id", submittedData.vpbx_id);
    formData.append("no_of_audios", submittedData.no_of_audios);
    formData.append("type", submittedData.type);
    for (let i = 0; i < mediaArray.length; i++) {
      const key = mediaArray[i];
      formData.append(key, submittedData[key]);
    }

    if (selectedType !== "") {
      let api = "";
      if (auth.role === "2") {
        api = "updateIvrSounds";
      } else {
        api = "user-updateIvrSounds";
      }

      axios
        .post(url + api, formData, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        })
        .then(
          (response) => {
            if (response.status === 200) {
              if (response.data.status === true) {
                setTimeout(() => {
                  setLoader(false);
                  toast.success("Sound added successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 1000,
                  });
                }, 1000);

                setTimeout(() => {
                  window.location.reload();
                }, 1500);
              } else {
                setLoader(false);
                toast.error("Please upload files", {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1000,
                });
              }
            }
          },
          (error) => {
            console.log(error);
            setLoader(false);
          }
        );
    } else {
      setLoader(false);
    }
  };

  const handleFile = (e, data) => {
    var file = e.target.files[0];

    var temp = [...mediaArray];
    temp.push(data);

    var unique = temp.filter(onlyUnique);
    setMediaArray(unique);

    setSubmittedData({
      ...submittedData,
      [data]: file,
    });
  };
  useEffect(() => {
    AudioForm();
  }, []);

  const AudioForm = () => {
    let api = "";
    if (auth.role === "2") {
      api = "getTypeInfo";
    } else {
      api = "user-getTypeInfo";
    }
    axios
      .post(
        url + api,
        {
          vpbx_id: auth.vpbx_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then(
        (response) => {
          if (response.data.status === true) {
            if (
              response.data.message === "Data Not Found" &&
              response.data.data.length === 0
            ) {
              setAudioForm([]);
            } else if (response.data.message === "Data Found") {
              setAudioForm(response.data.data);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  function onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
  }

  useEffect(() => {
    if (selectedType !== "") {
      let result = audioForm.filter((val) => {
        return val.type === selectedType;
      });
      if (result.length > 0) {
        setSubmittedData({
          ...submittedData,
          no_of_audios: result[0].no_of_audios,
        });
        setNoOfAudios(result[0].no_of_audios);
      }
    }
  }, [selectedType]);
  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-large">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <h3>VPBX MANAGER</h3>
                {auth.role === "2" && (
                  <p>
                    Use this page to create new call routing, forward calls, set
                    up conference calls, manage existing extensions, and much
                    more.
                  </p>
                )}
              </div>
            </div>

            <div className="uk-width-1-1 ">
              <ul
                className="uk-subnav callSwitcher"
                id="renderSwitcher"
                uk-switcher="connect: .callClass"
              >
                {(auth.role === "2" || auth.role === "3") && (
                  <>
                    {auth.role === "2" || checkPermissions("sound-settings") ? (
                      <li
                        className="uk-active"
                        onClick={() =>
                          navigate("/outbound-sound-setting", { replace: true })
                        }
                      >
                        <a href="#">Sound settings</a>
                      </li>
                    ) : null}

                    {auth.role === "2" || checkPermissions("customized-ivr") ? (
                      <li
                        onClick={() =>
                          navigate("/outbound-customized-ivr", { replace: true })
                        }
                      >
                        <a href="#">Customized IVR</a>
                      </li>
                    ) : null}
                  </>
                )}
              </ul>
            </div>
          </div>
          <ul className="uk-switcher uk-margin callClass">
            {(auth.role === "2" || auth.role === "3") && (
              <>
                {/* {auth.role === "2" || checkPermissions("sound-settings") ? ( */}
                {auth.role === "2"? (
                  <li>
                    <div className="dashboardWrp">
                      <div className="uk-container">
                        <div className="dashboardTop">
                          <div uk-grid="" className="uk-grid uk-grid-small">
                            <div className="uk-width-2-3">
                              <div className="dashboardIntro">
                                <h3>Sound Settings</h3>
                              </div>
                            </div>
                          </div>

                          <form action="javascript:void(0);">
                            <div className="formCreateMain">
                              <div className="uk-grid uk-grid-small">
                                <div className="uk-width-1-1@m uk-margin-top">
                                  <legend className="uk-legend">
                                    Sound Setting
                                  </legend>
                                </div>
                                <div className="uk-width-1-1@m uk-margin">
                                  <label>Type</label>
                                  <select
                                    className="uk-select"
                                    aria-label="Select"
                                    value={selectedType}
                                    onChange={(e) => {
                                      setSubmittedData({
                                        ...submittedData,
                                        type: e.target.value,
                                      });
                                      setMediaArray([]);
                                      setSelectedType(e.target.value);
                                    }}
                                  >
                                    <option value="">Select Type</option>
                                    {audioForm.map((item) => (
                                      <option
                                        key={item.type_id}
                                        value={item.type}
                                      >
                                        {item.type}
                                      </option>
                                    ))}
                                  </select>

                                  {errorEnable && selectedType === "" && (
                                    <div>please select type</div>
                                  )}
                                </div>

                                {selectedType && (
                                  <div className="hidden">
                                    {audioForm.map((item) =>
                                      item.type == selectedType
                                        ? item.audio_names.map(
                                            (audio, index) => (
                                              <div
                                                key={item.type_id}
                                                className="uk-grid"
                                                uk-grid
                                              >
                                                <div className="uk-width-1-2@m uk-margin-top">
                                                  <label>
                                                    <b>{audio}</b>
                                                  </label>
                                                  <span className="fileDisc">
                                                    Add sound file (only .wav
                                                    format allowed)
                                                  </span>
                                                  <div className="uk-margin-bottom">
                                                    <div uk-form-custom="target: true">
                                                      <input
                                                        type="file"
                                                        aria-label="Custom controls"
                                                        accept=".wav"
                                                        // onChange={
                                                        //   (e) =>
                                                        //     handleFileUpload(
                                                        //       e.target.files[0],
                                                        //       audio,
                                                        //       index
                                                        //     )

                                                        //   // handleFileUpload(e.target.files, audio, index)
                                                        // }
                                                        onChange={(e) =>
                                                          handleFile(e, audio)
                                                        }
                                                      />
                                                      <input
                                                        className="uk-input uk-form-width-medium"
                                                        type="text"
                                                        placeholder="Choose files"
                                                        aria-label="Custom controls"
                                                        disabled
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="uk-width-1-2@m uk-margin-top">
                                                  <label>
                                                    <b>Sound File </b>
                                                  </label>
                                                  <audio controls>
                                                    <source
                                                      // src={audio}
                                                      src={
                                                        audio === "en"
                                                          ? `https://cap.zong.com.pk:8444/vpbx-apis/usr_sounds/${auth.vpbx_id}/en/${audio}.wav`
                                                          : audio === "ur"
                                                          ? `https://cap.zong.com.pk:8444/vpbx-apis/usr_sounds/${auth.vpbx_id}/ur/${audio}.wav`
                                                          : `https://cap.zong.com.pk:8444/vpbx-apis/usr_sounds/${auth.vpbx_id}/${audio}.wav`
                                                      }
                                                      type="audio/wav"
                                                    />
                                                    Your browser does not
                                                    support the audio element.
                                                  </audio>
                                                </div>
                                              </div>
                                            )
                                          )
                                        : ""
                                    )}
                                  </div>
                                )}
                                {(auth.role === "2" ||
                                  checkIndividualPermission(
                                    "incoming-calls",
                                    "read_and_write"
                                  )) && (
                                  <div className="uk-width-1-1@m uk-float-right">
                                    <div className="formActionBtn uk-text-right">
                                      <button
                                        className="pinkBtn"
                                        onClick={createIvr}
                                      >
                                        {loader ? (
                                          <div uk-spinner="" className="loader">
                                            Adding
                                          </div>
                                        ) : (
                                          "Update"
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                )}
                                {/* {(auth.role === "2" ||
                {checkIndividualPermission(
                  "sound-settings",
                  "read_and_write"
                ) && (
                  
                )}
                )} */}
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </li>
                ) : null}
                {/* {auth.role === "2" || checkPermissions("customized-ivr") ? ( */}
                {auth.role === "2"  ? (
                  <li></li>
                ) : null}
              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OutboundSoundSetting;
